<template>
  <div class="white-wrapper">
    <div class="section-title">
      {{ $t("Cashier Session Reconcillation") }}
    </div>
    <div class="mt-3 mb-2">
      <div class="row">
        <div class="col-3 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label
              :class="
                dropDown.cinemas && dropDown.cinemas.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :disabled="isRoleID"
              :options="dropDown.cinemas"
              v-model="dropDown.selectedCinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_id"
              placeholder="Select Cinema"
              @input="onSelectCinema($event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>
        <div class="col-2 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <!-- <button class="btn-clearDate" v-if="fromDate">
                      ✖
                    </button> -->
              <Datepicker
                :monday-first="true"
                type="date"
                ref="programaticOpen"
                v-model="fromDate"
                v-validate="'required'"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">
                <!-- {{ $t("show") }} -->
                {{ $t("fromdate") }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-2 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <!-- <button class="btn-clearDate" v-if="toDate">
                      ✖
                    </button> -->
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="toDate"
                v-validate="'required'"
              >
              </Datepicker>
              <label :class="toDate ? 'active' : ''">
                <!-- {{ $t("show") }}  -->
                {{ $t("todate") }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-3 mb-4">
          <div class="dropdown-curve-container mr-2">
            <multiselect
              :options="posUsers"
              v-model="selectedUsers"
              :customLabel="setLabel"
              track-by="user_id"
              placeholder="Select Users"
              :showLabels="false"
              :multiple="true"
            >
            </multiselect>
          </div>
        </div>

        <div class="col-lg-6 col-xl-2 align-self-center mb-3">
          <button
            class="btn-blue-lg w-100"
            @click.prevent="GetUserSessionReconcillation('N')"
          >
            {{ $t("fetch") }}
            {{ $t("report") }}
          </button>
        </div>

        <div
          class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- s -->
          <a
            target="_blank"
            @click="GetUserSessionReconcillation('Y')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
      </div>
    </div>

    <div class="cashier-recon">
      <div
        v-for="(report, rIndex) in reports"
        :key="`user_wise_` + rIndex"
        class="report"
      >
        <!-- User Header -->
        <h5 class="main-header">User : {{ report.user }}</h5>

        <!-- Sales Table -->
        <table class="sales-table cashier-table" border="1" cellspacing="0" cellpadding="4">
          <thead>
            <tr>
              <th></th>
              <th>Price</th>
              <th colspan="2">Sales</th>
              <th colspan="2">Refunds</th>
              <th colspan="2">Gross</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th>Qty</th>
              <th>Value</th>
              <th>Qty</th>
              <th>Value</th>
              <th>Qty</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <!-- Ticket Sales -->
            <tr class="section-header">
              <td colspan="8">Ticket Sales</td>
            </tr>
            <tr
              v-for="(item, i) in report.ticketSalesDetails"
              :key="`ticket_sales_` + rIndex + i"
            >
              <td>{{ item.name }}</td>
              <td class="text-right">{{ formatCurrency(item.price) }}</td>
              <td class="text-right">{{ item.qty }}</td>
              <td class="text-right">{{ formatCurrency(item.value) }}</td>
              <td class="text-right">{{ item.refund_admits }}</td>
              <td class="text-right">
                {{ formatCurrency(item.refund_value) }}
              </td>
              <td class="text-right">{{ item.qty - item.refund_admits }}</td>
              <td class="text-right">
                {{ formatCurrency(item.value - item.refund_value) }}
              </td>
            </tr>
            <tr class="total-row">
              <td colspan="2">Total Tickets</td>
              <td class="text-right">{{ ticketTotals(report).qty }}</td>
              <td class="text-right">
                {{ formatCurrency(ticketTotals(report).value) }}
              </td>
              <td class="text-right">{{ ticketTotals(report).refund_qty }}</td>
              <td class="text-right">
                {{ formatCurrency(ticketTotals(report).refund_value) }}
              </td>
              <td class="text-right">{{ ticketTotals(report).gross_qty }}</td>
              <td class="text-right">
                {{ formatCurrency(ticketTotals(report).gross_value) }}
              </td>
            </tr>

            <!-- Concession Sales -->
            <tr class="section-header">
              <td colspan="8">Concession Sales</td>
            </tr>
            <template
              v-for="(category, cIndex) in report.concessionSales.categories"
            >
              <tr
                class="category-header"
                :key="`concession_sales_` + rIndex + cIndex"
              >
                <td colspan="8">{{ category.name }}</td>
              </tr>
              <tr v-for="(item, j) in category.items" :key="j">
                <td class="pl10">{{ item.name }}</td>
                <td class="text-right">{{ formatCurrency(item.price) }}</td>
                <td class="text-right">{{ item.qty }}</td>
                <td class="text-right">{{ formatCurrency(item.value) }}</td>
                <td class="text-right">{{ item.refund_admits }}</td>
                <td class="text-right">
                  {{ formatCurrency(item.refund_value) }}
                </td>
                <td class="text-right">{{ item.qty - item.refund_admits }}</td>
                <td class="text-right">
                  {{ formatCurrency(item.value - item.refund_value) }}
                </td>
              </tr>
              <tr class="total-row">
                <td class="pl10">Total</td>
                <td></td>
                <td class="text-right">{{ categoryTotals(category).qty }}</td>
                <td class="text-right">
                  {{ formatCurrency(categoryTotals(category).value) }}
                </td>
                <td class="text-right">
                  {{ categoryTotals(category).refund_qty }}
                </td>
                <td class="text-right">
                  {{ formatCurrency(categoryTotals(category).refund_value) }}
                </td>
                <td class="text-right">
                  {{ categoryTotals(category).gross_qty }}
                </td>
                <td class="text-right">
                  {{ formatCurrency(categoryTotals(category).gross_value) }}
                </td>
              </tr>
            </template>
            <tr class="total-row">
              <td colspan="2">Total Concessions</td>
              <td class="text-right">{{ concessionTotals(report).qty }}</td>
              <td class="text-right">
                {{ formatCurrency(concessionTotals(report).value) }}
              </td>
              <td class="text-right">
                {{ concessionTotals(report).refund_qty }}
              </td>
              <td class="text-right">
                {{ formatCurrency(concessionTotals(report).refund_value) }}
              </td>
              <td class="text-right">
                {{ concessionTotals(report).gross_qty }}
              </td>
              <td class="text-right">
                {{ formatCurrency(concessionTotals(report).gross_value) }}
              </td>
            </tr>

            <!-- Overall Total -->
            <tr class="total-row">
              <td colspan="7">Total Sales</td>
              <td class="text-right">
                {{ formatCurrency(totalSales(report)) }}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Payments -->
        <h4 class="section-header">Payments</h4>
        <table
          class="payments-table cashier-table"
          border="1"
          cellspacing="0"
          cellpadding="4"
        >
          <tbody>
            <tr
              v-for="(p, idx) in report.payments"
              :key="`payment_` + rIndex + idx"
            >
              <td>{{ p.method }}</td>
              <td class="text-right">{{ formatCurrency(p.total_amount) }}</td>
            </tr>
            <tr class="total-row">
              <td>Total Payment</td>
              <td class="text-right">
                {{
                  formatCurrency(
                    report.payments.reduce((acc, p) => acc + p.total_amount, 0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>

        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";

export default {
  components: {
    NoRecords
  },
  data() {
    return {
      isRoleID: false,
      BASEURL,
      submitted: false,
      posUsers: [],
      selectedUsers: [],
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      fromDate: new Date(),
      toDate: new Date(),
      CinemasCopy: [],
      reports: []
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  methods: {
    moment,
    setLabel(event) {
      if (event.first_name && event.first_name.length > 0) {
        return `${event.first_name ? event.first_name : ""} ${
          event.last_name ? event.last_name : ""
        }`;
      } else {
        return event.username;
      }
    },
    getCinemaList: function() {
      MasterService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.fetchPosUsersList(event.cine_id);
      this.$store.dispatch("selectDropdownCinema", event);
    },
    fetchPosUsersList(cinema_id = null) {
      let self = this;
      if (cinema_id) {
        let body = {
          role_id: "4, 8",
          cinema_id: cinema_id
        };
        MasterService.GetActiveUsersAccordingRolesList(body)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records) {
              self.posUsers = data.Records;
              console.log("this.posUsers", this.posUsers);
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch(error => {
            console.log("error :>> ", error);
          });
      } else {
        this.$toasted.show("Please Select Cinema");
      }
    },
    formatCurrency(val) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(val || 0);
    },
    ticketTotals(report) {
      return {
        qty: report.ticketSalesDetails.reduce((a, i) => a + i.qty, 0),
        value: report.ticketSalesDetails.reduce((a, i) => a + i.value, 0),
        refund_qty: report.ticketSalesDetails.reduce(
          (a, i) => a + i.refund_admits,
          0
        ),
        refund_value: report.ticketSalesDetails.reduce(
          (a, i) => a + i.refund_value,
          0
        ),
        gross_qty: report.ticketSalesDetails.reduce(
          (a, i) => a + (i.qty - i.refund_admits),
          0
        ),
        gross_value: report.ticketSalesDetails.reduce(
          (a, i) => a + (i.value - i.refund_value),
          0
        )
      };
    },
    categoryTotals(category) {
      return {
        qty: category.items.reduce((a, i) => a + i.qty, 0),
        value: category.items.reduce((a, i) => a + i.value, 0),
        refund_qty: category.items.reduce((a, i) => a + i.refund_admits, 0),
        refund_value: category.items.reduce((a, i) => a + i.refund_value, 0),
        gross_qty: category.items.reduce(
          (a, i) => a + (i.qty - i.refund_admits),
          0
        ),
        gross_value: category.items.reduce(
          (a, i) => a + (i.value - i.refund_value),
          0
        )
      };
    },
    concessionTotals(report) {
      return report.concessionSales.categories.reduce(
        (totals, category) => {
          const ct = this.categoryTotals(category);
          return {
            qty: totals.qty + ct.qty,
            value: totals.value + ct.value,
            refund_qty: totals.refund_qty + ct.refund_qty,
            refund_value: totals.refund_value + ct.refund_value,
            gross_qty: totals.gross_qty + ct.gross_qty,
            gross_value: totals.gross_value + ct.gross_value
          };
        },
        {
          qty: 0,
          value: 0,
          refund_qty: 0,
          refund_value: 0,
          gross_qty: 0,
          gross_value: 0
        }
      );
    },
    totalSales(report) {
      return (
        this.ticketTotals(report).gross_value +
        this.concessionTotals(report).gross_value
      );
    },
    GetUserSessionReconcillation(isPdf = "N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        userIds: this.selectedUsers.map(user => user.user_id),
        isPdf
      };
      ReportsService.GetCashierSessionReconcillation(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.reports.length) {
            this.reports = data.reports;
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.reports = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    }
  }
};
</script>

<style>
.cashier-recon {
  font-size: 12px;
}
.main-header {
  font-weight: bold;
  margin: 10px 0;
}
.section-header {
  font-weight: bold;
  margin: 10px 0 5px 0;
}
.category-header {
  font-weight: bold;
  background: #f0f0f0;
}
.total-row {
  font-weight: bold;
  background: #e0e0e0;
}
.text-right {
  text-align: right;
}
.pl10 {
  padding-left: 10px;
}
.cashier-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.cashier-table th,
.cashier-table td {
  padding: 5px 15px 5px 15px;
  color: #000;
  border: 1px solid #dee2e6 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/CashierSessionReconcillation.vue